import {useTranslation} from "react-i18next";
import {AvailableLoadsByInsight, AvailableLoadsByInsightProps} from "./AvailableLoadsByInsight";

export type AvailableLoadsByCompanyInsightProps = Omit<AvailableLoadsByInsightProps, 'title' | "defaultType" | "showSelect">

export const AvailableLoadsByCompanyInsight = (props: AvailableLoadsByCompanyInsightProps) => {
  const {...rest} = props

  const {t} = useTranslation()

  return (
    <AvailableLoadsByInsight
      {...rest}
      title={t<string>("common.insight.availloadsbycompany", "Avail. Loads By Company")}
      defaultType="company"/>
  )
}
